import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-card-user',
  templateUrl: './card-user.component.html',
  styleUrls: ['./card-user.component.css']
})
export class CardUserComponent {
  @Input() data: any[];
  @Input() urlPath: string;
  @Output() editClick = new EventEmitter<any>();
  @Output() deleteClick = new EventEmitter<any>();
  @Output() enableClick = new EventEmitter<any>();
  @Output() showProfile = new EventEmitter<any>();
}
